<template lang="pug">
	.category-filters
		.category-filters__row
			.category-filters__col.category-filters__col--filters
				template(v-if="isEmptyFilters")
					.category-filters__title {{ $t('filters.title') }}

					ul.category-filters__list
						template(v-for="(filter, index) in filters")
							li.category-filters__list-item(v-if="filter.list.length > 0" :key="index")
								button.category-filters__list-link(@click.prevent="toggleFilter(filter)"
																										:class="{ active: filter.activeFilter }") {{ filter.name }}

								ul.category-filters__sublist(v-if="filter.activeFilter")
									template(v-if="filter.name === $t('filters.list.color')")
										li.category-filters__sublist-item(v-for="(item, index) in filter.list" :key="index")
											a.category-filters__sublist-image(v-if="item"
																												href="#"
																												@click.prevent="toggleSubfilter(filter, item.name), sendFilteredProducts()"
																												:class="{ active: filter.selectedFilters.includes(item.name) }")
													i.icon
														svg-icon.icon-check(name="check")
													img.lazyload(src="/img/img-preloader.svg"
																				:data-src="item[0]" 
																				:alt="item.name"
																				:title="item.name")

									template(v-else-if="filter.name === $t('filters.list.size')")
										li.category-filters__sublist-item(v-for="(item, index) in filter.list" :key="index")
											a.category-filters__sublist-link(href="#"
																												@click.prevent="toggleSubfilter(filter, item), sendFilteredProducts()"
																												:class="{ active: filter.selectedFilters.includes(item) }") {{ item.replace(`-${$cookies.get('locale')}`, '') }}

									template(v-else)
										li.category-filters__sublist-item(v-for="(item, index) in filter.list" :key="index")
											a.category-filters__sublist-link(href="#"
																												@click.prevent="toggleSubfilter(filter, item), sendFilteredProducts()"
																												:class="{ active: filter.selectedFilters.includes(item) }") {{ item }}

									button.close(@click.prevent="toggleFilter(filter)")
										svg-icon.icon-close-filters(name="close-filters")

					//- Sale filters
					a.category-filters__sale(href="#" @click.prevent="toggleSale(), sendFilteredProducts()") {{ $t('filters.list.sale') }}

			//- Sorting
			.category-filters__col.category-filters__col--sorting(v-if="isEmptyFilters")
				.category-filters__title {{ $t('sorting.title') }}
				.category-filters__sorting
					Multiselect(v-model="sorting.value",
											:options="sorting.options",
											:searchable="false",
											:show-labels="false",
											:allow-empty="false",
											:close-on-select="true",
											@input="sendFilteredProducts"
											@select="toggleSort()")
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },

  props: {
    products: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      filteredProducts: [],
      filters: [
        {
          name: this.$t('filters.list.size'),
          list: [],
          activeFilter: false,
          selectedFilters: []
        },
        {
          name: this.$t('filters.list.color'),
          list: [],
          activeFilter: false,
          selectedFilters: []
        },
        {
          name: this.$t('filters.list.heel'),
          list: [],
          activeFilter: false,
          selectedFilters: []
        },
        {
          name: this.$t('filters.list.ocassion'),
          list: [],
          activeFilter: false,
          selectedFilters: []
        }
      ],
      sorting: {
        value: this.$t('sorting.list.latest'),
        options: [
          this.$t('sorting.list.latest'),
          this.$t('sorting.list.lowPrice'),
          this.$t('sorting.list.highPrice'),
          this.$t('sorting.list.popular')
        ]
      },
      sale: false,
      sort: false
    }
  },

  computed: {
    sizeFilters() {
      const sizes = _(this.products)
        .flatMap('attributes')
        .filter({ name: 'Size' })
        .map('options')
        .flatten()
        .uniq()
        .sortBy()
        .value()

      let result = null

      if (this.$cookies.get('locale') === 'en') {
        result = sizes
      } else {
        result = sizes.map(size => `${size}-${this.$cookies.get('locale')}`)
      }

      return result
    },

    colorFilters() {
      const result = _(this.products)
        .flatMap('attributes')
        .filter({ name: 'Color' })
        .map('attribute_data_color')
        .flatten()
        .uniqBy('name')
        .value()

      return result
    },

    heelFilters() {
      const result = _(this.products)
        .flatMap('attributes')
        .filter({ name: 'Heel Height' })
        .map('options')
        .flatten()
        .uniq()
        .sortBy()
        .value()

      return result
    },

    ocassionFilters() {
      const result = _(this.products)
        .flatMap('attributes')
        .filter({ name: 'Occasion' })
        .map('options')
        .flatten()
        .uniq()
        .sortBy()
        .value()

      return result
    },

    isEmptyFilters() {
      let result = true

      for (const filter of this.filters) {
        if (filter.list.length !== 0) {
          result = true
        }
      }

      return result
    }
  },

  created() {
    this.filters[0].list = this.sizeFilters
    this.filters[1].list = this.colorFilters
    this.filters[2].list = this.heelFilters
    this.filters[3].list = this.ocassionFilters

    this.filteredProducts = this.products
  },

  methods: {
    toggleFilter(filter) {
      if (filter.activeFilter === false) {
        this.filters.map(item => (item.activeFilter = false))
        filter.activeFilter = true
      } else {
        filter.activeFilter = false
      }
    },

    toggleSubfilter(filter, item) {
      if (filter.selectedFilters.includes(item)) {
        const index = filter.selectedFilters.indexOf(item)
        filter.selectedFilters.splice(index, 1)

        if (filter.selectedFilters.length === 0) {
          filter.activeFilter = false
        }
      } else {
        filter.selectedFilters.push(item)
      }
    },

    toggleSale() {
      if (this.sale) {
        this.sale = false
      } else {
        this.sale = true
      }
    },

    toggleSort() {
      this.sort = true
    },

    sendFilteredProducts() {
      const filterBySize = filter => {
        let matches = []

        Array.prototype.push.apply(matches, this.filteredProducts)

        this.filteredProducts = matches.filter(item =>
          item.product_variations.some(
            v =>
              filter.selectedFilters.includes(
                v.variation_attributes.attribute_pa_sizes
              ) && v.in_stock
          )
        )
      }
      const filterByAll = (filter, filterName) => {
        let matches = []

        Array.prototype.push.apply(matches, this.filteredProducts)

        this.filteredProducts = matches.filter(item =>
          item.attributes.some(attr => {
            if (attr.name === filterName) {
              return attr.options.some(option =>
                filter.selectedFilters.includes(option)
              )
            }
          })
        )
      }
      const filterBySale = () => {
        let matches = []

        Array.prototype.push.apply(matches, this.filteredProducts)

        this.filteredProducts = matches.filter(item => item.on_sale)
      }
      const sortProducts = () => {
        let matches = []

        Array.prototype.push.apply(matches, this.filteredProducts)

        // Сортировка товаров
        switch (this.sorting.value) {
          case this.$t('sorting.list.latest'):
            this.filteredProducts = _.orderBy(
              matches,
              ['date_created'],
              ['desc']
            )
            break

          case this.$t('sorting.list.lowPrice'):
            this.filteredProducts = _.orderBy(matches, ['price'], ['asc'])
            break

          case this.$t('sorting.list.highPrice'):
            this.filteredProducts = _.orderBy(matches, ['price'], ['desc'])
            break

          case this.$t('sorting.list.popular'):
            this.filteredProducts = _.orderBy(
              matches,
              ['total_sales'],
              ['desc']
            )
            break

          default:
            console.log('Something wrong!')
            break
        }
      }

      this.filteredProducts = []
      Array.prototype.push.apply(this.filteredProducts, this.products)

      for (const filter of this.filters) {
        if (
          filter.name === this.$t('filters.list.size') &&
          filter.selectedFilters.length > 0
        ) {
          filterBySize(filter)
        }

        if (
          filter.name === this.$t('filters.list.color') &&
          filter.selectedFilters.length > 0
        ) {
          filterByAll(filter, 'Color')
        }

        if (
          filter.name === this.$t('filters.list.heel') &&
          filter.selectedFilters.length > 0
        ) {
          filterByAll(filter, 'Heel Height')
        }

        if (
          filter.name === this.$t('filters.list.ocassion') &&
          filter.selectedFilters.length > 0
        ) {
          filterByAll(filter, 'Occasion')
        }
      }

      if (this.sale) {
        filterBySale()
      }

      if (this.sort) {
        sortProducts()
      }

      // Передача отфильтрованых товаров родительскому компоненту
      this.$emit('filterProducts', this.filteredProducts)
    }
  }
}
</script>

<style lang="scss">
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.category-filters {
  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  &__col,
  &__list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__col {
    position: relative;

    &--filters {
      @include mobile {
        margin-left: -10px;
        margin-right: -10px;
      }

      .category-filters__title {
        @include mobile {
          display: none;
        }
      }
    }

    &--sorting {
      @include mobile {
        margin-top: 10px;
      }
    }
  }

  &__title {
    font-size: 12px;
    letter-spacing: 1px;
    line-height: 1.2;
    text-transform: uppercase;

    @include mobile {
      font-size: 10px;
    }
  }

  &__list {
    margin-left: 20px;

    @include mobile {
      margin-left: 0;
    }

    &-item {
      margin-right: 10px;

      @include mobile {
        margin-right: 3px;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    &-link {
      position: relative;
      z-index: 1;
      display: block;
      padding: 6.5px 10px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.3;
      letter-spacing: 1px;
      text-transform: uppercase;
      transition: all 0.3s;

      @include mobile {
        padding: 4px 8px;
        font-size: 10px;
      }

      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        bottom: 5px;
        left: 10px;
        right: 10px;
        height: 1px;
        background-color: $blackColor;
      }

      &:after {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 2px;
        box-shadow: 1px 5px 10px rgba(124, 200, 221, 0.45);
        background-color: $blueColor;
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover,
      &.active {
        &:after {
          opacity: 1;
        }
      }
    }
  }

  &__sublist {
    position: absolute;
    z-index: 10;
    top: calc(100% + 10px);
    left: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @include mobile {
      left: 10px;
    }

    &-item {
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }

    &-link {
      position: relative;
      user-select: none;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        width: 100%;
        box-shadow: 1px 5px 10px rgba(124, 200, 221, 0.45);
        border-radius: 2px;
        background-color: $blueColor;
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover,
      &.active {
        &:after {
          opacity: 1;
        }
      }
    }

    &-image {
      position: relative;
      display: block;
      border-radius: 50%;
      user-select: none;

      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 0;
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:before {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        border: 0px solid $whiteColor;
        border-radius: 50%;
        transition: border-width 0.3s;
      }

      &:hover,
      &.active {
        &:before {
          border-width: 3px;
        }
      }

      &.active {
        .icon {
          opacity: 1;
        }
      }
    }
  }

  &__sale {
    margin-left: 20px;
    color: #d8433c;
    font-size: 12px;
    letter-spacing: 1px;
    text-transform: uppercase;

    @include mobile {
      margin-left: 10px;
      margin-top: 5px;
      font-size: 10px;
    }
  }

  // Sorting
  &__sorting {
    margin-left: 15px;

    @include mobile {
      margin-left: 10px;
    }

    .multiselect {
      font-size: 12px;
      text-align: right;

      @include mobile {
        font-size: 10px;
      }

      &__select {
        display: none;
      }

      &__tags {
        padding: 0;
        color: rgba($blackColor, 0.5);
        font-size: 12px;
        text-transform: uppercase;
        border: 0;
        border-radius: 0;
        background-color: transparent;
        cursor: pointer;

        @include mobile {
          font-size: 10px;
        }
      }

      &__input,
      &__single {
        font-size: 12px;

        @include mobile {
          font-size: 10px;
        }
      }

      &__content-wrapper {
        top: calc(100% + 10px);
        right: 0;
        width: 180px;
        background: transparent;
        border-radius: 0;

        @include mobile {
          background-color: $whiteColor;
        }
      }

      &__content {
        overflow: hidden;
      }

      &__element {
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &__option {
        padding: 0;
        color: $blackColor;
        font-size: 14px;
        line-height: 1.35;

        @include mobile {
          font-size: 12px;
        }

        > span {
          position: relative;

          &:before {
            content: '';
            position: absolute;
            top: 4px;
            left: -15px;
            display: block;
            width: 10px;
            height: 10px;
            background-color: $blueColor;
            border-radius: 50%;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s;
          }
        }

        &--highlight {
          background: transparent;
          outline: none;

          > span {
            &:before {
              opacity: 0.5;
              visibility: visible;
            }
          }
        }

        &--selected {
          background: transparent;

          &:before {
            display: none;
          }

          > span {
            position: relative;

            &:before {
              opacity: 1;
              visibility: visible;
            }
          }
        }
      }
    }
  }
}
</style>
